var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "form",
    {
      staticClass: "payroll-detail",
      on: {
        submit: function($event) {
          $event.preventDefault()
          return _vm.onSubmit($event)
        }
      }
    },
    [
      _c("div", { staticClass: "columns is-multiline is-centered" }, [
        _c(
          "div",
          { staticClass: "column is-6" },
          [
            _c("PayrollDetails", {
              attrs: { loading: _vm.loading, disabled: _vm.loading }
            })
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "column is-6" },
          [
            _c("PayrollReceiver", {
              attrs: { loading: _vm.loading, disabled: _vm.loading }
            })
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "column is-12" },
          [
            _c("PayrollPercepts", {
              attrs: { loading: _vm.loading, disabled: _vm.loading }
            })
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "column is-12" },
          [
            _c("PayrollDeductions", {
              attrs: { loading: _vm.loading, disabled: _vm.loading }
            })
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "column is-12" },
          [
            _c("PayrollOtherPayments", {
              attrs: { loading: _vm.loading, disabled: _vm.loading }
            })
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "column is-12" },
          [
            _c("PayrollPaidLeaves", {
              attrs: { loading: _vm.loading, disabled: _vm.loading }
            })
          ],
          1
        ),
        _c("div", { staticClass: "column is-12 action-buttons" }, [
          _vm.stamped || _vm.canceled
            ? _c("div", { staticClass: "field is-grouped" }, [
                _c(
                  "p",
                  { staticClass: "control" },
                  [
                    _c(
                      "RouterLink",
                      {
                        staticClass: "button",
                        class: { "is-loading": _vm.isLoading },
                        attrs: {
                          disabled: _vm.isLoading,
                          to: {
                            name: "SaleNoteList",
                            query: { size: 20, page: 1 }
                          }
                        }
                      },
                      [_vm._v("\n            Regresar\n          ")]
                    )
                  ],
                  1
                )
              ])
            : _c("div", { staticClass: "field is-grouped" }, [
                _c(
                  "p",
                  { staticClass: "control" },
                  [
                    _c(
                      "RouterLink",
                      {
                        staticClass: "button",
                        class: { "is-loading": _vm.isLoading },
                        attrs: {
                          disabled: _vm.isLoading,
                          to: {
                            name: "PayrollsList",
                            query: { size: 20, page: 1 }
                          }
                        }
                      },
                      [_vm._v("\n            Regresar\n          ")]
                    )
                  ],
                  1
                )
              ])
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }